// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5633":"b5903afe","6000":"f906d813","8687":"2778bd53"}[chunkId] + ".chunk.css";
};